import { isDate } from './type-utils'

export function clone(obj: any) {
  if (obj == null || typeof obj !== 'object') {
    return obj
  }

  let temp: any = null

  if (isDate(obj)) {
    temp = new Date(obj.getTime())
  } else {
    temp = obj.constructor()
    for (const key in obj) {
      temp[key] = clone(obj[key])
    }
  }

  return temp
}
